import * as yup from 'yup'

const SchemaValidations = yup.object().shape({
  startDate: yup.date().nullable(),
  endDate: yup.date().nullable(),
})

export default SchemaValidations
